const roleDashboardComponent = () => import('@/views/dashboard/roles/RoleDashboardPage.vue')

export default [
    {
        path: '/dashboard/analytics',
        name: 'dashboard-analytics',
        component: () => import('@/views/dashboard/analytics/Analytics.vue'),
    },
    {
        path: '/dashboard/overview',
        name: 'dashboard-overview',
        component: () => import('@/views/dashboard/ecommerce/Dashboard.vue'),
    },
    {
        path: '/dashboard/ecommerce',
        name: 'dashboard-ecommerce',
        component: () => import('@/views/dashboard/ecommerce/Dashboard.vue'),
    },
    {
        path: '/dashboard/super-user',
        name: 'dashboard-super-user',
        component: roleDashboardComponent,
        props: { dashboardKey: 'superuser' },
    },
    {
        path: '/dashboard/regional-data-officer',
        name: 'dashboard-regional-data-officer',
        component: roleDashboardComponent,
        props: { dashboardKey: 'regionaldataofficer' },
    },
    {
        path: '/dashboard/shipping-officer',
        name: 'dashboard-shipping-officer',
        component: roleDashboardComponent,
        props: { dashboardKey: 'shippingofficer' },
    },
    {
        path: '/dashboard/data-clerk',
        name: 'dashboard-data-clerk',
        component: roleDashboardComponent,
        props: { dashboardKey: 'dataclerk' },
    },
    {
        path: '/dashboard/data-processing-coordinator',
        name: 'dashboard-data-processing-coordinator',
        component: roleDashboardComponent,
        props: { dashboardKey: 'dataprocessingcoordinator' },
    },
    {
        path: '/dashboard/external-users',
        name: 'dashboard-external-users',
        component: roleDashboardComponent,
        props: { dashboardKey: 'externalusers' },
    },
    {
        path: '/dashboard/stores-officer',
        name: 'dashboard-stores-officer',
        component: roleDashboardComponent,
        props: { dashboardKey: 'storesofficer' },
    },
    {
        path: '/dashboard/warehouse-operation-manager',
        name: 'dashboard-warehouse-operation-manager',
        component: roleDashboardComponent,
        props: { dashboardKey: 'warehouseoperationmanager' },
    },
    {
        path: '/dashboard/data-processing-manager',
        name: 'dashboard-data-processing-manager',
        component: roleDashboardComponent,
        props: { dashboardKey: 'dataprocessingmanager' },
    },
    {
        path: '/dashboard',
        name: 'dashboard',
        component: () => import('@/views/dashboard/roles/RoleDashboardRedirect.vue'),
    },
]
